export default __webpack_public_path__ + "static/media/web.7cae1318.jpg";